
define('text!presentation/common/actionModal/views/unsavedChangesAction.html',[],function () { return '<span class="action-modal__action-text" data-bind="i18n: content().i18n"/>';});

